import { GET_PAYOR_DATA_BY_NAME, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { useQuery } from "react-query";
import { getPayorDataByName } from "api/payors";

export const useGetPayorDataByName = (payorName: "silna" | "enter" | "candid") => {
  const { data, isLoading, ...rest } = useQuery(
    [GET_PAYOR_DATA_BY_NAME, payorName],
    () => getPayorDataByName(payorName),
    {
      enabled: !!payorName,
      staleTime: STALE_TIME_5_MINUTES,
    }
  );
  return {
    payorData: data?.data || null,
    payorDataLoading: isLoading,
    ...rest,
  };
};
